{
  "actions": {
    "apply": "Применить",
    "cancel": "Отмена",
    "clear": "Очистить",
    "close": "Закрыть",
    "confirm": "Подтвердить",
    "delete": "Удалить",
    "done": "Готово",
    "edit": "Редактировать",
    "more": "Ещё",
    "remove": "Убрать",
    "retry": "Повторить",
    "save": "Сохранить"
  },
  "states": {
    "loading": "Загрузка…",
    "saving": "Сохранение…"
  },
  "time": {
    "justNow": "только что"
  },
  "validation": {
    "required": "Обязательное поле"
  },
  "errors": {
    "aborted": "Запрос отменён",
    "badRequest": "Не удалось выполнить запрос. Проверьте данные и попробуйте ещё раз.",
    "conflict": "Данные изменились, пока вы их редактировали. Обновите страницу и попробуйте снова.",
    "forbidden": "У вас нет доступа к этому разделу.",
    "forbiddenTitle": "Нет доступа",
    "gone": "Это больше недоступно.",
    "network": "Нет соединения с сервером. Проверьте подключение к интернету.",
    "notFound": "Объект не найден или был удалён.",
    "rateLimited": "Слишком много запросов. Подождите немного и повторите.",
    "renderFailed": "Не удалось отобразить содержимое",
    "renderFailedHint": "Закройте панель и попробуйте открыть её снова.",
    "server": "На сервере произошла ошибка. Попробуйте ещё раз чуть позже.",
    "tooLarge": "Файл слишком большой.",
    "unauthorized": "Сессия истекла. Войдите снова.",
    "unknown": "Что-то пошло не так",
    "validation": "Проверьте правильность заполнения полей.",
    "adminNetwork": "Вы администратор, но не из этой сети: роль администратора доступна только из разрешённых сетей (Администрирование → Безопасность входа). Подключитесь из офиса или через VPN."
  },
  "fileErrors": {
    "invalid_multipart": "Загрузка прервалась или файл повреждён. Попробуйте ещё раз.",
    "invalid_thumbnail_size": "Такой размер превью недоступен.",
    "multipart_required": "Не удалось отправить файл. Попробуйте ещё раз.",
    "no_file": "Выберите файл для загрузки.",
    "not_found": "Файл не найден или удалён.",
    "scan_pending": "Файл ещё проверяется на вирусы. Попробуйте через минуту.",
    "signature_expired": "Срок действия ссылки на файл истёк. Обновите страницу.",
    "signature_invalid": "Ссылка на файл недействительна.",
    "signature_missing": "Ссылка на файл неполная.",
    "thumbnail_not_ready": "Превью ещё не готово.",
    "too_large": "Файл слишком большой.",
    "quota_exceeded": "Вы загрузили слишком много за сутки. Попробуйте позже.",
    "upload_pending_limit": "Слишком много незавершённых загрузок. Завершите или отмените часть из них.",
    "upload_expired": "Загрузка устарела. Начните её заново.",
    "upload_not_found": "Загрузка не найдена. Начните её заново.",
    "upload_chunk_invalid": "Часть файла повреждена. Загрузите файл заново.",
    "upload_size_invalid": "Нельзя загрузить пустой файл частями."
  },
  "session": {
    "unreachableTitle": "Сервер недоступен",
    "unreachableHint": "Не удалось подключиться к Orbita. Проверьте соединение и повторите попытку."
  },
  "avatarStack": {
    "label_one": "{{count}} участник",
    "label_few": "{{count}} участника",
    "label_many": "{{count}} участников",
    "label_other": "{{count}} участника",
    "andMore_one": "и ещё {{count}}",
    "andMore_few": "и ещё {{count}}",
    "andMore_many": "и ещё {{count}}",
    "andMore_other": "и ещё {{count}}"
  },
  "pickers": {
    "choosePerson": "Выберите сотрудника",
    "choosePeople": "Выберите сотрудников",
    "chooseGroup": "Выберите группу",
    "chooseGroups": "Выберите группы",
    "chooseDepartment": "Выберите подразделение",
    "chooseDepartments": "Выберите подразделения",
    "searchPeople": "Поиск сотрудников…",
    "searchGroups": "Поиск групп и проектов…",
    "searchDepartments": "Поиск подразделений…",
    "noPeople": "Никого не нашли",
    "noGroups": "Группы не найдены",
    "noDepartments": "Подразделения не найдены",
    "people": "Сотрудники",
    "group": "Группа",
    "project": "Проект",
    "members_one": "{{count}} участник",
    "members_few": "{{count}} участника",
    "members_many": "{{count}} участников",
    "members_other": "{{count}} участника",
    "loadError": "Не удалось загрузить список"
  },
  "audience": {
    "everyone": "Все сотрудники",
    "add": "Добавить",
    "choose": "Выбрать получателей",
    "tabs": {
      "users": "Сотрудники",
      "departments": "Отделы",
      "groups": "Группы"
    }
  },
  "date": {
    "pickDate": "Выберите дату",
    "pickDateTime": "Выберите дату и время",
    "pickRange": "Выберите период",
    "time": "Время",
    "today": "Сегодня",
    "presets": {
      "today": "Сегодня",
      "yesterday": "Вчера",
      "thisWeek": "Эта неделя",
      "last7Days": "Последние 7 дней",
      "thisMonth": "Этот месяц",
      "last30Days": "Последние 30 дней",
      "thisYear": "Этот год"
    }
  },
  "table": {
    "columns": "Колонки",
    "toggleColumns": "Показывать колонки",
    "empty": "Нет данных",
    "sortBy": "Сортировать по полю «{{column}}»",
    "range": "{{from}}–{{to}} из {{total}}",
    "selected_one": "Выбрана {{count}} строка",
    "selected_few": "Выбрано {{count}} строки",
    "selected_many": "Выбрано {{count}} строк",
    "selected_other": "Выбрано {{count}} строки",
    "rowsPerPage": "Строк на странице",
    "page": "Страница {{page}} из {{pages}}",
    "firstPage": "Первая страница",
    "previousPage": "Предыдущая страница",
    "nextPage": "Следующая страница",
    "lastPage": "Последняя страница",
    "selectAll": "Выбрать все строки",
    "selectRow": "Выбрать строку"
  },
  "files": {
    "attach": "Прикрепить",
    "browse": "Выберите файлы",
    "orDrop": "или перетащите их сюда",
    "dropzoneLabel": "Загрузить файлы",
    "maxSize": "До {{max}} на файл",
    "tooLarge": "«{{name}}» больше {{max}}",
    "notAccepted": "Файл «{{name}}» здесь не поддерживается",
    "tooMany_one": "Можно прикрепить не больше {{count}} файла",
    "tooMany_few": "Можно прикрепить не больше {{count}} файлов",
    "tooMany_many": "Можно прикрепить не больше {{count}} файлов",
    "tooMany_other": "Можно прикрепить не больше {{count}} файла",
    "failed": "Ошибка",
    "cancelUpload": "Отменить загрузку",
    "scanPending": "Проверяется на вирусы…",
    "scanClean": "Проверено",
    "scanInfected": "Вирус найден, файл удалён",
    "retrying": "Соединение прервалось, повтор {{attempt}}…",
    "offline": "Нет сети — загрузка продолжится сама",
    "resumed": "Продолжаем: {{size}} уже на сервере",
    "download": "Скачать",
    "openInNewTab": "Открыть в новой вкладке",
    "preview": "Просмотр «{{name}}»",
    "previewFailed": "Не удалось загрузить предпросмотр.",
    "noPreview": "Для этого типа файлов нет предпросмотра.",
    "previous": "Предыдущий файл",
    "next": "Следующий файл",
    "remove": "Убрать «{{name}}»"
  },
  "richText": {
    "placeholder": "Напишите что-нибудь…",
    "toolbar": "Форматирование",
    "undo": "Отменить",
    "redo": "Повторить",
    "textStyle": "Стиль текста",
    "paragraph": "Обычный текст",
    "heading": "Заголовок {{level}}",
    "bold": "Жирный",
    "italic": "Курсив",
    "underline": "Подчёркнутый",
    "strike": "Зачёркнутый",
    "code": "Код",
    "link": "Ссылка",
    "linkUrl": "Адрес ссылки",
    "invalidUrl": "Введите корректный адрес, например https://example.com",
    "removeLink": "Удалить ссылку",
    "bulletList": "Маркированный список",
    "orderedList": "Нумерованный список",
    "taskList": "Чек-лист",
    "quote": "Цитата",
    "codeBlock": "Блок кода",
    "divider": "Разделитель",
    "callout": "Выноска",
    "callouts": {
      "info": "Заметка",
      "tip": "Совет",
      "warning": "Внимание",
      "danger": "Важно"
    },
    "removeCallout": "Убрать выноску",
    "mention": "Упомянуть сотрудника",
    "mentionPeople": "Упоминание сотрудника",
    "image": "Изображение",
    "uploadingImage": "Загружаем «{{name}}»…",
    "imageUploaded": "Изображение добавлено",
    "table": "Таблица",
    "insertTable": "Вставить таблицу",
    "addRow": "Добавить строку",
    "addColumn": "Добавить колонку",
    "toggleHeader": "Строка заголовков",
    "deleteRow": "Удалить строку",
    "deleteColumn": "Удалить колонку",
    "deleteTable": "Удалить таблицу",
    "dropImagesOnly": "В текст можно вставить только изображения. Другие файлы прикрепите."
  },
  "comments": {
    "title": "Комментарии",
    "placeholder": "Напишите комментарий…",
    "send": "Отправить",
    "showEarlier": "Показать предыдущие комментарии",
    "empty": "Комментариев пока нет",
    "emptyHint": "Начните обсуждение первым.",
    "loadError": "Не удалось загрузить комментарии",
    "edited": "изменено",
    "you": "вы",
    "deleteTitle": "Удалить комментарий?",
    "deleteDescription": "Комментарий будет удалён без возможности восстановления."
  },
  "reactions": {
    "add": "Добавить реакцию",
    "whoReacted": "Кто отреагировал",
    "toggle_one": "{{reaction}}: {{count}} реакция",
    "toggle_few": "{{reaction}}: {{count}} реакции",
    "toggle_many": "{{reaction}}: {{count}} реакций",
    "toggle_other": "{{reaction}}: {{count}} реакции",
    "like": "Нравится",
    "love": "Супер",
    "laugh": "Смешно",
    "wow": "Удивительно",
    "sad": "Грустно",
    "angry": "Возмутительно"
  },
  "kanban": {
    "empty": "Перетащите карточку сюда",
    "instructions": "Чтобы взять карточку, нажмите пробел. Перемещайте стрелками, пробел или Enter — отпустить, Escape — отменить. Enter открывает карточку.",
    "pickedUp": "Карточка {{id}} взята",
    "over": "Над колонкой «{{column}}»",
    "dropped": "Карточка перемещена в колонку «{{column}}»",
    "cancelled": "Перемещение отменено",
    "scrollLeft": "Прокрутить влево",
    "scrollRight": "Прокрутить вправо"
  },
  "sidePanel": {
    "title": "Панель",
    "copyLink": "Скопировать ссылку",
    "linkCopied": "Ссылка скопирована",
    "unavailable": "Панель недоступна",
    "unknownType": "Модуль, который открывает панели «{{type}}», не установлен."
  },
  "inlineEdit": {
    "empty": "Не указано"
  },
  "placeholder": {
    "badge": "Скоро",
    "title": "Раздел в разработке",
    "description": "Команда уже работает над этим модулем. Навигация и интерфейс портала готовы — возможности ниже появятся в ближайших версиях."
  },
  "messengerTabs": {
    "label": "Разделы мессенджера"
  },
  "security": {
    "showPassword": "Показать пароль",
    "hidePassword": "Скрыть пароль",
    "actions": {
      "cancel": "Отмена",
      "done": "Готово"
    },
    "setup": {
      "title": "Включить двухфакторную аутентификацию",
      "description": "После пароля при входе потребуется код из приложения на телефоне.",
      "steps": "Шаги",
      "step": {
        "password": "Пароль",
        "scan": "Приложение",
        "codes": "Резервные коды"
      },
      "passwordHint": "Введите пароль, чтобы продолжить.",
      "password": "Ваш пароль",
      "scanHint": "Отсканируйте QR-код в приложении-аутентификаторе (Google Authenticator, Microsoft Authenticator, 2FAS, Aegis…) и введите 6-значный код, который оно покажет.",
      "qrAlt": "QR-код для приложения-аутентификатора",
      "manualKey": "Не получается отсканировать? Введите ключ",
      "copyKey": "Скопировать ключ",
      "manualHint": "Код по времени (TOTP), 6 цифр, 30 секунд.",
      "code": "6-значный код",
      "enabled": "Двухфакторная аутентификация включена.",
      "saved": "Я сохранил(а) резервные коды в надёжном месте",
      "next": "Продолжить",
      "confirm": "Включить",
      "done": "Завершить"
    },
    "recovery": {
      "title": "Резервные коды",
      "warning": "Сохраните эти коды сейчас: они показываются один раз. Каждый позволит войти один раз, если вы потеряете телефон.",
      "fileHeading": "Резервные коды Orbita (каждый работает один раз)",
      "copy": "Копировать",
      "copied": "Скопировано",
      "download": "Скачать",
      "print": "Печать"
    },
    "twoFactor": {
      "title": "Двухфакторная аутентификация",
      "description": "Код из приложения на телефоне вдобавок к паролю защищает учётную запись, даже если пароль утёк.",
      "on": "Включена",
      "off": "Выключена",
      "graceUntil": "Администратор требует двухфакторную аутентификацию. Включите её до {{date}}, иначе при входе её потребуют сначала.",
      "since": "Включена с {{date}}",
      "codesLeft_one": "Остался {{count}} резервный код.",
      "codesLeft_few": "Осталось {{count}} резервных кода.",
      "codesLeft_many": "Осталось {{count}} резервных кодов.",
      "codesLeft_other": "Осталось {{count}} резервных кодов.",
      "fewCodes": "Резервных кодов почти не осталось. Создайте новые, пока они не закончились.",
      "requiredNote": "Администратор требует двухфакторную аутентификацию, поэтому отключить её нельзя.",
      "newCodes": "Новые резервные коды",
      "turnOff": "Отключить",
      "turnOn": "Включить",
      "disabled": "Двухфакторная аутентификация отключена."
    },
    "disable": {
      "title": "Отключить двухфакторную аутентификацию",
      "description": "Подтвердите паролем и кодом из приложения (или резервным кодом).",
      "submit": "Отключить"
    },
    "regenerate": {
      "title": "Новые резервные коды",
      "description": "Старые коды перестанут работать. Подтвердите паролем и кодом из приложения.",
      "submit": "Создать коды",
      "done": "Сохраните новые коды. Старые больше не действуют."
    },
    "reauth": {
      "password": "Пароль",
      "code": "Код",
      "codePlaceholder": "123 456",
      "codeHint": "6-значный код из приложения или резервный код."
    },
    "sessions": {
      "title": "Устройства и сеансы",
      "description": "Где вы вошли в портал. Завершите то, что не узнаёте.",
      "empty": "Нет активных сеансов.",
      "loadError": "Не удалось загрузить сеансы.",
      "current": "Это устройство",
      "lastActive": "активность {{when}}",
      "signedIn": "вход {{when}}",
      "signOut": "Завершить",
      "signOutOthers": "Выйти на всех остальных",
      "confirmTitle": "Завершить сеанс «{{device}}»?",
      "confirmText": "На этом устройстве придётся войти заново. Открытые там страницы сразу перестанут получать обновления.",
      "confirmAllTitle": "Выйти на всех остальных устройствах?",
      "confirmAllText": "На всех остальных устройствах придётся войти заново. Это устройство останется в системе.",
      "signedOut": "Сеанс завершён.",
      "signedOutMany_one": "Завершён {{count}} сеанс.",
      "signedOutMany_few": "Завершено {{count}} сеанса.",
      "signedOutMany_many": "Завершено {{count}} сеансов.",
      "signedOutMany_other": "Завершено {{count}} сеансов."
    },
    "rules": {
      "title": "Требования к паролю",
      "length": "Минимальная длина: {{n}}",
      "distinct": "Разных символов — не меньше {{n}}",
      "mixedCase": "Строчная и заглавная буквы",
      "digit": "Цифра",
      "symbol": "Символ (не буква и не цифра)",
      "common": "Не из списка самых распространённых паролей",
      "history": "Отличается от прежних паролей (помним последние {{n}})"
    },
    "reasons": {
      "too_short": "Пароль слишком короткий: минимальная длина — {{n}}.",
      "few_distinct": "Используйте не меньше 4 разных символов.",
      "needs_mixed_case": "Нужны строчная и заглавная буквы.",
      "needs_digit": "Добавьте цифру.",
      "needs_symbol": "Добавьте символ.",
      "common": "Это один из самых распространённых паролей.",
      "reused": "Вы недавно уже использовали этот пароль (помним последние {{n}}).",
      "other": "Пароль не соответствует требованиям."
    },
    "restricted": {
      "signOut": "Выйти",
      "twoFactorTitle": "Настройте двухфакторную аутентификацию",
      "twoFactorText": "Администратор требует двухфакторную аутентификацию для вашей учётной записи. Настройте её, чтобы продолжить: нужна минута и приложение-аутентификатор на телефоне.",
      "passwordTitle": "Срок действия пароля истёк",
      "passwordText": "Администратор ограничил срок использования пароля. Выберите новый, чтобы продолжить."
    },
    "password": {
      "current": "Текущий пароль",
      "new": "Новый пароль",
      "confirm": "Повторите новый пароль",
      "mismatch": "Пароли не совпадают",
      "submit": "Сменить пароль"
    }
  },
  "truncation": {
    "showing": "Показано {{shown}} из {{total}}"
  },
  "roles": {
    "builtIn": {
      "admin": {
        "title": "Администратор",
        "description": "Все права, всегда. Не редактируется."
      },
      "user": {
        "title": "Сотрудник",
        "description": "Каждый сотрудник; не даёт административных прав."
      },
      "hr": {
        "title": "HR",
        "description": "Отключает сотрудников и передаёт их дела; права можно расширить."
      },
      "integrator": {
        "title": "Интегратор",
        "description": "Подключает портал к другим системам: вебхуки, настройки процессов, поисковый индекс, страницы состояния."
      },
      "auditor": {
        "title": "Аудитор",
        "description": "Читает журнал и страницы состояния; ничего не меняет."
      }
    }
  },
  "menuEditor": {
    "sections": {
      "primary": "Быстрый доступ",
      "main": "Меню",
      "admin": "Администрирование"
    },
    "drag": "Перетащить: {{label}}",
    "moveUp": "Выше: {{label}}",
    "moveDown": "Ниже: {{label}}",
    "hide": "Скрыть: {{label}}",
    "show": "Показать: {{label}}",
    "hiddenBadge": "Скрыт"
  },
  "history": {
    "off": "История изменений выключена администратором",
    "empty": "Изменений пока нет",
    "emptyHint": "Здесь будут видны правки полей: кто, когда и что изменил.",
    "more": "Показать ещё",
    "empty_value": "пусто",
    "yes": "да",
    "no": "нет",
    "showMore": "ещё",
    "less": "свернуть",
    "actor": {
      "unknown": "Неизвестный автор",
      "process": "Бизнес-процесс",
      "robot": "Робот",
      "trigger": "Триггер",
      "system": "Система"
    },
    "kind": {
      "process": "процесс",
      "robot": "робот",
      "trigger": "триггер",
      "system": "система",
      "api-token": "API-токен"
    },
    "fields": {
      "title": "Название",
      "status": "Статус / стадия",
      "category": "Воронка",
      "responsible": "Ответственный",
      "observers": "Наблюдатели",
      "description": "Описание",
      "firstName": "Имя",
      "lastName": "Фамилия",
      "secondName": "Отчество",
      "companyTitle": "Название компании",
      "position": "Должность",
      "phones": "Телефоны",
      "emails": "E-mail",
      "websites": "Сайты",
      "address": "Адрес",
      "source": "Источник",
      "sourceDescription": "Описание источника",
      "amount": "Сумма",
      "probability": "Вероятность",
      "expectedCloseDate": "Ожидаемая дата закрытия",
      "companyId": "Компания",
      "contactId": "Контакт",
      "dealId": "Сделка",
      "leadId": "Лид",
      "quoteId": "Предложение",
      "contacts": "Контакты",
      "companies": "Компании",
      "lossReason": "Причина провала",
      "lossComment": "Комментарий к провалу",
      "closedAt": "Закрыто",
      "birthday": "День рождения",
      "type": "Тип",
      "industry": "Отрасль",
      "employees": "Сотрудники",
      "revenue": "Годовой оборот",
      "number": "Номер",
      "issueDate": "Дата выставления",
      "validUntil": "Действует до",
      "dueDate": "Оплатить до",
      "paidAt": "Оплачено",
      "terms": "Условия",
      "beginDate": "Начало",
      "closeDate": "Окончание"
    },
    "keepForField": "Вести историю изменений"
  }
}
